import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';
import ContactModal from './ContactModal';

const styles = css`
  .ContactBanner {
    background-color: ${colors.brand1};
    ${''/* background-image: url('/images/pattern-01-dark.svg'); */}
    background-position: center center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
  }
  .ContactBanner_messageWrapper {
    display:flex;
    flex-flow:row nowrap;
    justify-content:center;
    padding:0 0 30px 0;
  }
  .ContactBanner_messageMedia {
    padding:0 20px 0 0;
  }
  .ContactBanner_messageMedia-image {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-size: cover;
    background-position: center center;
  }
  .ContactBanner_messageContent{
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
  }
  .ContactBanner_title {
    font:400 42px/1 ${typography.Serif};
    color: ${colors.white};
    margin: 0 0 10px 0;
  }
  .ContactBanner_subtitle {
    font:700 18px/1 color: ${colors.Condensed};
    color: ${colors.white};
    text-transform: uppercase;
    letter-spacing: 2px;
  }
  .ContactBanner_buttonWrapper {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }
  .ContactBanner_button {
    margin: 5px 10px;
  }
`;

function ContactBannerDetail({ widget, agent, product }) {
  return (
    <div className={styles}>
      <div className="ContactBanner">
        <div className="ContactBanner_messageWrapper">
          <div className="ContactBanner_messageMedia">
            {
              get(agent, 'logo') &&
              <div className="ContactBanner_messageMedia-image" style={{ backgroundImage: `url(${buildThumbnailUrl(get(agent, 'logo.contentUrl'), { width: 800, height: 800, exact: true })})` }} />
            }
          </div>
          <div className="ContactBanner_messageContent">
            <div className="ContactBanner_supertitle" />
            <div className="ContactBanner_title">
              {
                get(widget, `${product}_detail_contact_banner[0].heading`) &&
                <span>{get(widget, `${product}_detail_contact_banner[0].heading`)}</span>
              }
              {
                !get(widget, `${product}_detail_contact_banner[0].heading`) &&
                <span className="ContactBanner_title">Schedule A Showing</span>
              }
            </div>
            <div className="ContactBanner_subtitle">
              {
                get(widget, `${product}_detail_contact_banner[0].subheading`) &&
                <span>{get(widget, `${product}_detail_contact_banner[0].subheading`)}</span>
              }
              {
                !get(widget, `${product}_detail_contact_banner[0].subheading`) &&
                <span>{get(agent, 'name')} is here to help!</span>
              }
            </div>
          </div>
        </div>
        <div className="ContactBanner_buttonWrapper">
          <div className="ContactBanner_button">
            <a href={`tel:${get(agent, 'telephone').replace(/[^0-9]/g, '')}`} className="btn btn-hollow-white btn-phone-white">Call {get(agent, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '$1-$2-$3')}</a>
          </div>
          <div className="ContactBanner_button">
            <ContactModal>
              {
                get(widget, `${product}_detail_contact_banner[0].button_text`) &&
                <span className="btn btn-brand3 btn-chat-white" role="button">{get(widget, `${product}_detail_contact_banner[0].button_text`)}</span>
              }
              {
                !get(widget, `${product}_detail_contact_banner[0].button_text`) &&
                <span className="btn btn-brand3 btn-chat-white" role="button">Send Message</span>
              }
            </ContactModal>
          </div>
        </div>
      </div>
    </div>
  );
}

ContactBannerDetail.propTypes = {
  agent: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
  product: PropTypes.string.isRequired,
};

ContactBannerDetail.defaultProps = {
  agent: undefined,
  widget: undefined,
};

export default withData(
  {
    community: true,
    agent: true,
    widget: 'contact_banner',
  },
  {
    required: {
      agent: true,
      widget: true,
    },
  },
)(ContactBannerDetail);



// WEBPACK FOOTER //
// ./src/components/ContactBannerDetail.js